import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';

import awsRumActionTypes from '../consts/aws/awsRumActionTypes';
import rumCustomEvents from '../services/events/rumCustomEvents';
import {selectActiveDusn} from '../state/selectors/iotDevices';
import {selectCaptivePortalPage} from '../state/selectors/monitoring';
import {setPageParameters} from '../state/slice/monitoring';
import {dispatch} from '../state/store';

const usePageInteraction = () => {
    const captivePortalPage = useSelector(selectCaptivePortalPage);
    const [parentPage, setParentPage] = useState('');
    const {pathname, search} = useLocation();
    const dusn = useSelector(selectActiveDusn);

    useEffect(() => {
        const currentPage = captivePortalPage || `${pathname}${search}`;

        dispatch(setPageParameters(currentPage, parentPage));

        rumCustomEvents.recordAction({
            dusn,
            action: awsRumActionTypes.NAVIGATE,
            pageId: currentPage,
            parentPageInteractionId: parentPage,
        });

        setParentPage(currentPage);
    }, [pathname, search, captivePortalPage]);
};

export default usePageInteraction;
